import { completedBatchStatuses } from "../constants/completedBatchStatuses";

export const getMinerFeeCurrency = (batchStatus: number, currency: string) => {
  const minerFeeCurrency = completedBatchStatuses.includes(batchStatus)
    ? currency
    : "";

  return minerFeeCurrency;
};
